import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export type AVQuality = 'normal' | 'medium' | 'high'

export class AudioOptionsVM extends CommonOptionVM {
  required?: boolean
  allow_camera?: boolean
  photo_library?: boolean
  quality?: AVQuality
  max_length?: number

  constructor(data: Partial<AudioOptionsVM> = {}) {
    super(data)
    this.required = data?.required ?? false
    this.allow_camera = data?.allow_camera ?? false
    this.photo_library = data?.photo_library ?? false
    this.quality = data?.quality ?? 'normal'
    this.max_length = data?.max_length ?? 20
  }

  validateData() {
    const errors: any[] = []
    if (this.max_length && (this.max_length < 1 || this.max_length > 1800)) {
      errors.push({ key: 'max_length', error_message: '"Max length" must be between 1 and 1800' })
    }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default AudioOptionsVM